// import React, { useState, useEffect } from "react"
// import CountUp from "react-countup"
// import { Card, CardBody, Col, Row } from "reactstrap"

// const StatsCards = () => {
//   const [stats, setStats] = useState([])
//   const [loading, setLoading] = useState(true)

//   useEffect(() => {
//     const fetchStats = async () => {
//       try {
//         // Future mein yahan REAL API call daal dena
//         // const response = await fetch("/api/stats/upload-stats");
//         // const data = await response.json();

//         // Abhi ke liye mock/static data (baad mein API se replace kar dena)
//         const mockData = [
//           {
//             label: "New Uploaded",
//             value: 2847,
//             decimals: 0,
//             trend: "+12.6",
//             trendClass: "success",
//             trendIcon: "ri-arrow-up-line",
//             icon: "bx bx-upload",
//             bgColor: "success", // green
//           },
//           {
//             label: "Duplicate Skipped",
//             value: 549,
//             decimals: 0,
//             trend: "-3.2",
//             trendClass: "warning",
//             trendIcon: "ri-arrow-down-line",
//             icon: "bx bx-copy-alt",
//             bgColor: "warning", // yellow/orange
//           },
//           {
//             label: "Total Record",
//             value: 3396,
//             decimals: 0,
//             trend: "+9.4",
//             trendClass: "primary",
//             trendIcon: "ri-arrow-up-line",
//             icon: "bx bx-list-check",
//             bgColor: "primary", // blue
//           },
//         ]

//         setStats(mockData)
//         setLoading(false)
//       } catch (error) {
//         console.error("Failed to load stats:", error)
//         setLoading(false)
//       }
//     }

//     fetchStats()
//   }, [])

//   if (loading) {
//     return (
//       <Row>
//         <Col xl="12" className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </Col>
//       </Row>
//     )
//   }

//   return (
//     <Row>
//       {stats.map((item, index) => (
//         <Col xl="4" lg="4" md="6" sm="12" key={index} className="mb-4">
//           <Card className="shadow border-0 h-100 card-hover border-start border-5 border-primary">
//             <CardBody className="p-4">
//               <div className="d-flex align-items-center justify-content-between mb-3">
//                 <div>
//                   <p className="text-muted fw-medium mb-1 text-truncate">
//                     {item.label}
//                   </p>
//                   <h4 className="mb-0 fw-bold fs-3 ff-secondary text-dark">
//                     <CountUp
//                       start={0}
//                       end={item.value}
//                       duration={2.2}
//                       separator=","
//                       decimals={item.decimals}
//                       delay={0.1}
//                     />
//                   </h4>
//                 </div>

//                 <div className="flex-shrink-0">
//                   <div
//                     className={`avatar-md rounded-circle bg-soft-${item.bgColor} d-flex align-items-center justify-content-center`}
//                   >
//                     <i className={`fs-4 text-${item.bgColor} ${item.icon}`}></i>
//                   </div>
//                 </div>
//               </div>

//               <div className="d-flex align-items-center">
//                 <span
//                   className={`badge bg-soft-${item.trendClass} text-${item.trendClass} fs-13 px-2 py-1 me-2`}
//                 >
//                   <i className={`${item.trendIcon} align-middle me-1`}></i>
//                   {item.trend}%
//                 </span>
//                 <span className="text-muted fs-13">this month</span>
//               </div>
//             </CardBody>
//           </Card>
//         </Col>
//       ))}
//     </Row>
//   )
// }

// export default StatsCards

// import React, { useState, useEffect } from "react"
// import CountUp from "react-countup"
// import { Card, CardBody, Col, Row, Spinner, Alert } from "reactstrap"

// const StatsCards = () => {
//   const [stats, setStats] = useState({
//     new_uploaded: 0,
//     duplicates_skipped: 0,
//     total_in_database: 0,
//   })
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)

//   // Initial fetch (agar alag stats endpoint hai to yahan call karo)
//   useEffect(() => {
//     // Agar backend mein alag stats endpoint hai, to yahan call karo
//     // const fetchInitialStats = async () => {
//     //   try {
//     //     const response = await fetch("/api/upload/stats"); // ya getUploadStats()
//     //     const data = await response.json();
//     //     setStats({
//     //       new_uploaded: data.new_uploaded || 0,
//     //       duplicates_skipped: data.duplicates_skipped || 0,
//     //       total_in_database: data.total_in_database || 0,
//     //     });
//     //   } catch (err) {
//     //     setError("Failed to load initial stats");
//     //   } finally {
//     //     setLoading(false);
//     //   }
//     // };
//     // fetchInitialStats();

//     // Abhi ke liye initial 0 se start (upload hone pe update hoga)
//     setLoading(false)

//     // Listen for upload success event from UploadSection
//     const handleUploadSuccess = event => {
//       const uploadData = event.detail // backend se jo response aaya

//       if (uploadData) {
//         setStats({
//           new_uploaded: uploadData.new_uploaded || 0,
//           duplicates_skipped: uploadData.duplicates_skipped || 0,
//           total_in_database: uploadData.total_in_database || 0,
//         })
//       }
//     }

//     window.addEventListener("upload-success", handleUploadSuccess)

//     return () => {
//       window.removeEventListener("upload-success", handleUploadSuccess)
//     }
//   }, [])

//   if (loading) {
//     return (
//       <Row>
//         <Col xl="12" className="text-center py-5">
//           <Spinner color="primary" />
//         </Col>
//       </Row>
//     )
//   }

//   if (error) {
//     return (
//       <Row>
//         <Col xl="12">
//           <Alert color="danger">{error}</Alert>
//         </Col>
//       </Row>
//     )
//   }

//   const cardData = [
//     {
//       label: "New Uploaded",
//       value: stats.new_uploaded,
//       decimals: 0,
//       icon: "bx bx-upload",
//       bgColor: "success",
//     },
//     {
//       label: "Duplicate Skipped",
//       value: stats.duplicates_skipped,
//       decimals: 0,
//       icon: "bx bx-copy-alt",
//       bgColor: "warning",
//     },
//     {
//       label: "Total Record",
//       value: stats.total_in_database,
//       decimals: 0,
//       icon: "bx bx-list-check",
//       bgColor: "primary",
//     },
//   ]

//   return (
//     <Row>
//       {cardData.map((item, index) => (
//         <Col xl="4" lg="4" md="6" sm="12" key={index} className="mb-4">
//           <Card className="shadow border-0 h-100 card-hover border-start border-5 border-primary">
//             <CardBody className="p-4">
//               <div className="d-flex align-items-center justify-content-between mb-3">
//                 <div>
//                   <p className="text-muted fw-medium mb-1 text-truncate">
//                     {item.label}
//                   </p>
//                   <h4 className="mb-0 fw-bold fs-3 ff-secondary text-dark">
//                     <CountUp
//                       start={0}
//                       end={item.value}
//                       duration={2.2}
//                       separator=","
//                       decimals={item.decimals}
//                       delay={0.1}
//                     />
//                   </h4>
//                 </div>

//                 <div className="flex-shrink-0">
//                   <div
//                     className={`avatar-md rounded-circle bg-soft-${item.bgColor} d-flex align-items-center justify-content-center`}
//                   >
//                     <i className={`fs-4 text-${item.bgColor} ${item.icon}`}></i>
//                   </div>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </Col>
//       ))}
//     </Row>
//   )
// }

// export default StatsCards

import React, { useState, useEffect } from "react"
import CountUp from "react-countup"
import { Card, CardBody, Col, Row, Spinner, Alert } from "reactstrap"
import { getTotalRecordsCount } from "../../helpers/api_helper" // ← yeh import confirm karo

const StatsCards = () => {
  const [stats, setStats] = useState({
    new_uploaded: 0,
    duplicates_skipped: 0,
    total_in_database: 0,
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Page load pe TOTAL RECORDS fetch karo
  useEffect(() => {
    const fetchTotalCount = async () => {
      setLoading(true)
      setError(null)

      const result = await getTotalRecordsCount()

      if (result.success) {
        setStats(prev => ({
          ...prev,
          total_in_database: result.totalRecords || 0,
        }))
      } else {
        setError(result.error || "Failed to load total records count")
        console.error("Total records fetch failed:", result)
      }

      setLoading(false)
    }

    fetchTotalCount()

    // Optional: har 30 sec mein refresh (agar real-time chahiye)
    // const interval = setInterval(fetchTotalCount, 30000);
    // return () => clearInterval(interval);
  }, [])

  // Upload success se sirf new_uploaded aur duplicates_skipped update
  useEffect(() => {
    const handleUploadSuccess = event => {
      const uploadData = event.detail

      if (uploadData) {
        setStats(prev => ({
          ...prev,
          new_uploaded: uploadData.new_uploaded || 0,
          duplicates_skipped: uploadData.duplicates_skipped || 0,
          // total_in_database ko yahan mat chhedo – woh API se fresh rahega
        }))
      }
    }

    window.addEventListener("upload-success", handleUploadSuccess)

    return () => {
      window.removeEventListener("upload-success", handleUploadSuccess)
    }
  }, [])

  if (loading) {
    return (
      <Row>
        <Col xl="12" className="text-center py-5">
          <Spinner color="primary" />
          <p className="mt-2">Loading dashboard stats...</p>
        </Col>
      </Row>
    )
  }

  if (error) {
    return (
      <Row>
        <Col xl="12">
          <Alert color="danger">{error}</Alert>
        </Col>
      </Row>
    )
  }

  const cardData = [
    {
      label: "New Uploaded",
      value: stats.new_uploaded,
      decimals: 0,
      icon: "bx bx-upload",
      bgColor: "success",
    },
    {
      label: "Duplicate Skipped",
      value: stats.duplicates_skipped,
      decimals: 0,
      icon: "bx bx-copy-alt",
      bgColor: "warning",
    },
    {
      label: "Total Records",
      value: stats.total_in_database,
      decimals: 0,
      icon: "bx bx-list-check",
      bgColor: "primary",
    },
  ]

  return (
    <Row>
      {cardData.map((item, index) => (
        <Col xl="4" lg="4" md="6" sm="12" key={index} className="mb-4">
          <Card className="shadow border-0 h-100 card-hover border-start border-5 border-primary">
            <CardBody className="p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <p className="text-muted fw-medium mb-1 text-truncate">
                    {item.label}
                  </p>
                  <h4 className="mb-0 fw-bold fs-3 ff-secondary text-dark">
                    <CountUp
                      start={0}
                      end={item.value}
                      duration={2.2}
                      separator=","
                      decimals={item.decimals}
                      delay={0.1}
                    />
                  </h4>
                </div>

                <div className="flex-shrink-0">
                  <div
                    className={`avatar-md rounded-circle bg-soft-${item.bgColor} d-flex align-items-center justify-content-center`}
                  >
                    <i className={`fs-4 text-${item.bgColor} ${item.icon}`}></i>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default StatsCards
